module.exports = __webpack_public_path__ + "img/BAWS_Dagger4_1_3.cff5f200.png";